var _templateObject, _templateObject2, _templateObject3, _templateObject4;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import { css, keyframes } from '@emotion/core';
import { variables, media } from '@domain-group/fe-brary';
import { typography } from '@domain-group/fe-co-allhomes-design-system';
var colour = variables.colour;
var headingL = typography.headingL,
  body = typography.body,
  bodyBold = typography.bodyBold;
export var container = /*#__PURE__*/css("padding:20px 24px 24px 24px;background:", colour.neutral0, ";animation:none;user-select:none;", media('>=tablet'), "{padding:24px 80px 24px 28px;}> *{margin-bottom:16px;:last-child{margin-bottom:0;}}");
export var title = /*#__PURE__*/css(headingL);
export var subtitle = /*#__PURE__*/css("color:", colour.neutral700, ";");
export var subtitlePrefix = {
  name: "1bpvmlm",
  styles: "padding-right:12px;"
};
export var subtitleSuffix = {
  name: "vxcmzt",
  styles: "display:inline-flex;"
};
var animations = {
  exitToLeft: keyframes(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    from {\n      opacity: 1;\n      transform: translateX(0px);\n    }\n    to {\n      opacity: 0;\n      transform: translateX(-30px);\n    }\n  "]))),
  enterFromLeft: keyframes(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    from {\n      opacity: 0;\n      transform: translateX(-30px);\n    }\n    to {\n      opacity: 1;\n      transform: translateX(0px);\n    }\n  "]))),
  exitToRight: keyframes(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    from {\n      opacity: 1;\n      transform: translateX(0px);\n    }\n    to {\n      opacity: 0;\n      transform: translateX(30px);\n    }\n  "]))),
  enterFromRight: keyframes(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    from {\n      opacity: 0;\n      transform: translateX(30px);\n    }\n    to {\n      opacity: 1;\n      transform: translateX(0px);\n    }\n  "])))
};
export var animation = param => /*#__PURE__*/css("animation:", animations[param], " 0.4s;");
export var address = /*#__PURE__*/css("background:", colour.neutral100, ";padding:16px;>:first-child{margin-bottom:16px;}");
export var addressBody = /*#__PURE__*/css(body);
export var features = /*#__PURE__*/css("display:flex;color:", colour.neutral700, ";div{display:flex;margin-right:8px;>:first-child{margin-right:4px;}}");
export var feature = /*#__PURE__*/css(bodyBold);